import {BehaviorSubject} from 'rxjs';
import {rollStep} from "./rollStep";

import {
    IRoller,
    IRollerRoll,
    IRollerResult,
} from "../_interfaces/IRoller";
import {s_char} from "../_signals/s_char";
import {s_char_attr_step} from "../_signals/s_char_attr";
import {v4} from "uuid";
import ccAttribute from "./ccAttribute";
import {modSum} from "../_signals/s_char_calc";
import {ResultsAdd} from "../_api/BEResult";
import {IResult} from "../_interfaces/IResult";
import {s_app_cid, s_app_rid, s_app_sl} from "../_signals/s_app";

const resultDefaults: IRollerResult = {
    time: 0,
    step: 0,
    step_mod: 0,
    result: 0,
    rolled: '',
    karma: '',
    successes: 0,
    success: false,
    vs: '',
    vsnum: -1,
    as: ''
}

const rollDefaults: IRollerRoll = {
    attribute: '',
    canusekarma: false,
    karma: false,
    step: 0,
    step_mod: 0,
    strain: 0,
    title: '',
    target: [],
    targetVS: '',
    vs: '',
    vsnum: 0,
    as: '',
    as_fix: false
}

const roller: IRoller = {
    open: false,
    rolled: false,
    roll: rollDefaults,
    result: resultDefaults
}

const rollerSubscriber = new BehaviorSubject(roller);

const rollerOpen = () => {
    rollerSubscriber.next({...rollerSubscriber.value, open: true});
}

const rollerClose = () => {
    rollerSubscriber.next({...rollerSubscriber.value, open: false});
}

const rollerSetVS = (vs: string) => {
    rollerSubscriber.next({...rollerSubscriber.value, roll: {...rollerSubscriber.value.roll, vs: vs}});
}
const rollerSetVSNum = (vsnum: number) => {
    rollerSubscriber.next({...rollerSubscriber.value, roll: {...rollerSubscriber.value.roll, vsnum: vsnum}});
}

const rollerSetKarma = (karma: boolean) => {
    rollerSubscriber.next({...rollerSubscriber.value, roll: {...rollerSubscriber.value.roll, karma: karma}});

}

const rollerSetRolled = (rolled: boolean) => {
    rollerSubscriber.next({...rollerSubscriber.value, rolled: rolled});

}

const rollerSetResult = (result: IRollerResult) => {
    rollerSubscriber.next({...rollerSubscriber.value, result: result});

}

const rollerSetRoll = (roll: IRollerRoll, open = false, rolled = false) => {

    let setDefault = rollDefaults;

    for (const prop in setDefault) if (roll.hasOwnProperty(prop)) setDefault[prop] = roll[prop]

    rollerSubscriber.next({
        open: open,
        rolled: rolled,
        roll: roll,
        result: resultDefaults
    });
}

const rollerClearResult = () => {
    rollerSubscriber.next({
        ...rollerSubscriber.value,
        rolled: false,
        result: resultDefaults
    });
}

const rollerRoll = () => {

    let roller = rollerSubscriber.value;

    let step = roller.roll.step;

    if (roller.roll.step_mod !== 0) step += roller.roll.step_mod;

    if (roller.roll.attribute !== '' && roller.roll.title !== ccAttribute(roller.roll.attribute, 'tt')) step += s_char_attr_step(roller.roll.attribute).value;

    if (roller.roll.as) {
        step += modSum(s_char.value.id, roller.roll.as);
    }

    roller.result = rollStep(step, roller.roll.karma, roller.roll.vsnum);
    roller.rolled = true;

    rollerSubscriber.next(roller);

    rollerCheck();

    const result: IResult = {
        id: v4(),
        rid: s_app_rid.value,
        cid: s_app_cid.value,
        title: roller.roll.title,
        name: s_char.value.name,
        nsc: s_char.value.nsc,
        sl: s_app_sl.value,
        eff: '',
        addEff: '',
        time: roller.result.time,
        step: roller.result.step,
        result: roller.result.result,
        rolled: roller.result.rolled,
        step_mod: roller.result.step_mod,
        karma: roller.result.karma,
        successes: roller.result.successes,
        success: roller.result.success,
        rollas: roller.roll.as,
        rollvs: roller.roll.vsnum
    };

    ResultsAdd(result);

    return result;

}

const rollerCheck = () => {

    const roller = rollerSubscriber.value;
    const vsnum = roller.roll.vsnum;

    if (vsnum < 1 || isNaN(roller.result.result)) {
        return;
    }

    let success = (roller.result.result >= vsnum);
    let successes = 0;
    let ms = 0;
    if (roller.result.result >= vsnum) {
        let rest = roller.result.result - vsnum;
        ms = Math.floor(rest / 5);
        successes += ms;
    }
    roller.result.successes = successes;
    roller.result.success = success;

    rollerSetResult(roller.result);
}

export {
    rollerSubscriber,
    rollerOpen,
    rollerClose,
    rollerSetRoll,
    rollerSetResult,
    rollerClearResult,
    rollerSetVS,
    rollerSetKarma,
    rollerSetRolled,
    rollerRoll,
    rollerCheck
}